import React, { useState } from 'react'
import { QuickLinkConfig } from './QuickLinkConfig'
import { Box, Card, Grid, IconButton, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import BentoBoxGrid from '../../../v2/MUI_custom_component/Bento/BentoBoxGrid';
import BentoItem from '../../../v2/MUI_custom_component/Bento/BentoItem';

const QuickLinks = ({ allowedKeys }) => {
  const isAllowed = (key) => {
    if (!allowedKeys || allowedKeys.length === 0) return true;
    return allowedKeys.includes(key);
  };
  const navigate = useNavigate();
  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow:'none',
        width: '100%',
        zIndex: 2,
      }}
    >
      <Typography variant="h2" mb={1}>
        Quick Links
      </Typography>
      <BentoBoxGrid rows={1} column={12} gap={{ xs: 1, md: 2 }}>
        {QuickLinkConfig.filter(link => isAllowed(link.key)).map((link, index) => (
          <BentoItem colSpan={4}>
            <Box key={index}
              sx={{
                textAlign: "center",
                p: 1,
                borderRadius: 3,
                cursor: "pointer",
                width: '100%',
              }}
              onClick={() => navigate(link.path)}
            >
              <IconButton>{link.icon}</IconButton>
              <Typography sx={{ color : '#666666', fontWeight: 600, fontSize: '13px', lineHeight: '20px' }}>{link.label}</Typography>
            </Box>
          </BentoItem>
        ))}
      </BentoBoxGrid>
    </Card>
  )
}

export default QuickLinks